import React, { useRef } from "react";
import axiosClient from "../../axios";

const SearchBar = ({ queryText, setFilteredInspections }) => {
  const timeoutRef = useRef(null);

  const handleChange = (e) => {
    const value = e.target.value;

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      handleSearch(value);
    }, 1000);
  };

  const handleSearch = async (value) => {
    try {
      // console.log(`Making request to /inspections/search_loaded/${value}`);
      const response = await axiosClient.get("/inspections/search_loaded/", {
        params: { search: value },
      });
      setFilteredInspections(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="w-1/2 mx-auto">
      <input
        type="text"
        onChange={handleChange}
        placeholder={queryText}
        className="w-1/2 p-2 rounded-2xl border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
    </div>
  );
};

export default SearchBar;
